export default {
  SALES: {
    id: 'admin_tools_shared_reason_sales',
    defaultMessage: 'Sales',
  },
  BUYBACK: {
    id: 'admin_tools_shared_reason_buyback',
    defaultMessage: 'Buyback',
  },
  REFUND_ISSUES: {
    id: 'admin_tools_shared_reason_refund_issues',
    defaultMessage: 'Refund issues',
  },
  REPAIR_COST: {
    id: 'admin_tools_shared_reason_repair_cost',
    defaultMessage: 'Repair cost',
  },
  TRANSPORT_ISSUES: {
    id: 'admin_tools_shared_reason_transport_issues',
    defaultMessage: 'Transport issues',
  },
  TRANSPORT_ISSUES_BUYBACK: {
    id: 'admin_tools_shared_reason_transport_issues_buyback',
    defaultMessage: 'Transport issues',
  },
  TRANSPORT_ISSUES_SALES: {
    id: 'admin_tools_shared_reason_transport_issues_sales',
    defaultMessage: 'Transport issues',
  },
  SHIPPING_CHARGES: {
    id: 'admin_tools_shared_reason_shipping_charges',
    defaultMessage: 'Shipping charges',
  },
  INVOICE_NOT_PROVIDED: {
    id: 'admin_tools_shared_reason_invoice_not_provided',
    defaultMessage: 'Invoice not provided',
  },
  BM_SERVICE_FEE: {
    id: 'admin_tools_shared_reason_bm_service_fee',
    defaultMessage: 'BM service fee',
  },
  PROMO_CODE: {
    id: 'admin_tools_shared_reason_promo_code',
    defaultMessage: 'Promo code',
  },
  MISSING_ACCESSORIES: {
    id: 'admin_tools_shared_reason_missing_accessories',
    defaultMessage: 'Missing accessories',
  },
  MISSING_ACCESSORIES_SALES: {
    id: 'admin_tools_shared_reason_missing_accessories_sales',
    defaultMessage: 'Missing accessories',
  },
  MISSING_ACCESSORIES_REFURBISHER_CHARTER_BREACH: {
    id: 'admin_tools_shared_reason_missing_accessories_refurbisher_charter_breach',
    defaultMessage: 'Missing accessories',
  },
  PRODUCT_NOT_COMPLIANT: {
    id: 'admin_tools_shared_reason_product_not_compliant',
    defaultMessage: 'Product not compliant',
  },
  SEASONAL: {
    id: 'admin_tools_shared_reason_seasonal',
    defaultMessage: 'Seasonal',
  },
  COMMERCIAL_GESTURE: {
    id: 'admin_tools_shared_reason_commercial_gesture',
    defaultMessage: 'Commercial gesture',
  },
  COMMERCIAL_GESTURE_BUYBACK: {
    id: 'admin_tools_shared_reason_commercial_gesture_buyback',
    defaultMessage: 'Commercial gesture',
  },
  COMMERCIAL_GESTURE_REPAIR_COST: {
    id: 'admin_tools_shared_reason_commercial_gesture_repair_cost',
    defaultMessage: 'Commercial gesture',
  },
  COMMERCIAL_GESTURE_SHIPPING_CHARGES: {
    id: 'admin_tools_shared_reason_commercial_gesture_shipping_charges',
    defaultMessage: 'Commercial gesture',
  },
  REFURBISHER_CHARTER_BREACH: {
    id: 'admin_tools_shared_reason_refurbisher_charter_breach',
    defaultMessage: 'Refurbisher charter breach',
  },
  PAYMENT_ISSUE: {
    id: 'admin_tools_shared_reason_payment_issue',
    defaultMessage: 'Payment issue',
  },
  OTHER: {
    id: 'admin_tools_shared_reason_other',
    defaultMessage: 'Other',
  },
  OTHER_BUYBACK: {
    id: 'admin_tools_shared_reason_other_buyback',
    defaultMessage: 'Other',
  },
  OTHER_TRANSPORT_ISSUES: {
    id: 'admin_tools_shared_reason_other_transport_issues',
    defaultMessage: 'Other',
  },
  OTHER_MISSING_ACCESSORIES: {
    id: 'admin_tools_shared_reason_other_missing_accessories',
    defaultMessage: 'Other',
  },
  OTHER_COMMERCIAL_GESTURE: {
    id: 'admin_tools_shared_reason_other_commercial_gesture',
    defaultMessage: 'Other',
  },
  OTHER_WITH_ORDER: {
    id: 'admin_tools_shared_reason_other_with_order',
    defaultMessage: 'Other (with order)',
  },
  OTHER_WITHOUT_ORDER: {
    id: 'admin_tools_shared_reason_other_without_order',
    defaultMessage: 'Other (no order)',
  },
  PAYPAL: {
    id: 'admin_tools_shared_reason_paypal',
    defaultMessage: 'PayPal',
  },
  PAYPAL_AUTOMATIC_CR: {
    id: 'admin_tools_shared_reason_paypal_automatic_cr',
    defaultMessage: 'PayPal automatic CR',
  },
  ONEY: {
    id: 'admin_tools_shared_reason_oney',
    defaultMessage: 'Oney',
  },
  CREDIT_CARD_AND_OTHER: {
    id: 'admin_tools_shared_reason_credit_card_and_other',
    defaultMessage: 'Credit Card and other',
  },
  BM_WARRANTY: {
    id: 'admin_tools_shared_reason_bm_warranty',
    defaultMessage: 'BM warranty',
  },
  BM_WARRANTY_REFUND_ISSUES: {
    id: 'admin_tools_shared_reason_bm_warranty_refund_issues',
    defaultMessage: 'BM warranty',
  },
  BM_WARRANTY_REPAIR_COST: {
    id: 'admin_tools_shared_reason_bm_warranty_repair_cost',
    defaultMessage: 'BM warranty',
  },
  SELLER_AGREES: {
    id: 'admin_tools_shared_reason_seller_agrees',
    defaultMessage: 'Seller agrees',
  },
  SELLER_CHARTER_BREACH: {
    id: 'admin_tools_shared_reason_seller_charter_breach',
    defaultMessage: 'Seller charter breach',
  },
  COLISSIMO: {
    id: 'admin_tools_shared_reason_colissimo',
    defaultMessage: 'Colissimo',
  },
  DHL_EXPRESS: {
    id: 'admin_tools_shared_reason_dhl_express',
    defaultMessage: 'DHL Express',
  },
  DPD: {
    id: 'admin_tools_shared_reason_dpd',
    defaultMessage: 'DPD',
  },
  CHRONOPOST: {
    id: 'admin_tools_shared_reason_chronopost',
    defaultMessage: 'Chronopost',
  },
  SELLER_RESPONSIBILITY: {
    id: 'admin_tools_shared_reason_seller_responsibility',
    defaultMessage: 'Seller responsiblity',
  },
  RECEIVED_AFTER_ORDER: {
    id: 'admin_tools_shared_reason_received_after_order',
    defaultMessage: 'Received after order',
  },
  GIFT_CARD_TO_REFUND: {
    id: 'admin_tools_shared_reason_gift_card_to_refund',
    defaultMessage: 'Gift card to refund',
  },
  INSURANCE: {
    id: 'admin_tools_shared_reason_insurance',
    defaultMessage: 'Insurance',
  },
  SMARTPHONE_CHARGER: {
    id: 'admin_tools_shared_reason_smartphone_charger',
    defaultMessage: 'Smartphone - charger (without cable)',
  },
  SMARTPHONE_CABLE: {
    id: 'admin_tools_shared_reason_smartphone_cable',
    defaultMessage: 'Smartphone - cable',
  },
  SMARTPHONE_SIM: {
    id: 'admin_tools_shared_reason_smartphone_sim',
    defaultMessage: 'Smartphone - SIM card extractor',
  },
  SMARTPHONE_BATTERY: {
    id: 'admin_tools_shared_reason_smartphone_battery',
    defaultMessage: 'Smartphone - battery',
  },
  LAPTOP_PC_CHARGER: {
    id: 'admin_tools_shared_reason_laptop_pc_charger',
    defaultMessage: 'Laptop - PC charger',
  },
  LAPTOP_MAC_CHARGER: {
    id: 'admin_tools_shared_reason_laptop_mac_charger',
    defaultMessage: 'Laptop - Mac charger',
  },
  LAPTOP_MAC_KEYBOARD: {
    id: 'admin_tools_shared_reason_laptop_mac_keyboard',
    defaultMessage: 'Laptop - Mac keyboard',
  },
  LAPTOP_MAC_MOUSE: {
    id: 'admin_tools_shared_reason_laptop_mac_mouse',
    defaultMessage: 'Laptop - Mac mouse',
  },
  LOST_PARCEL_NOT_RECEIVED: {
    id: 'admin_tools_shared_reason_lost_parcel_not_received',
    defaultMessage: 'Lost parcel - Not received',
  },
  DAMAGED_PARCEL: {
    id: 'admin_tools_shared_reason_damaged_parcel',
    defaultMessage: 'Damaged parcel',
  },
  LOST_PARCEL_RECEIVED: {
    id: 'admin_tools_shared_reason_lost_parcel_received',
    defaultMessage: 'Lost parcel - Received',
  },
  EMPTY_PARCEL: {
    id: 'admin_tools_shared_reason_empty_parcel',
    defaultMessage: 'Empty parcel',
  },
  BUG_BACK_MARKET: {
    id: 'admin_tools_shared_reason_bug_back_market',
    defaultMessage: 'Bug Back Market',
  },
  COUNTER_OFFER_ARBITRATION: {
    id: 'admin_tools_shared_reason_counter_offer_arbitration',
    defaultMessage: 'Counter-offer arbitration',
  },
  MISTAKE: {
    id: 'admin_tools_shared_reason_mistake',
    defaultMessage: 'Customer mistake',
  },
  ABUSIVE_CO: {
    id: 'admin_tools_shared_reason_abusive_co',
    defaultMessage: 'Abusive CO',
  },
  NO_PROOF_CO: {
    id: 'admin_tools_shared_reason_no_proof_co',
    defaultMessage: 'No proof CO',
  },
  MISSING_ACTION_FROM_MERCHANT: {
    id: 'admin_tools_shared_reason_missing_action_from_merchant',
    defaultMessage: 'Missing action from merchant',
  },
  RETURN_FEES: {
    id: 'admin_tools_shared_reason_return_fees',
    defaultMessage: 'Return fees',
  },
  typeAll: {
    id: 'admin_tools_shared_reason_type_all',
    defaultMessage: 'All',
  },
  categoryAll: {
    id: 'admin_tools_shared_reason_category_all',
    defaultMessage: 'All',
  },
  subcategoryAll: {
    id: 'admin_tools_shared_reason_subcategory_all',
    defaultMessage: 'All',
  },
  detailAll: {
    id: 'admin_tools_shared_reason_detail_all',
    defaultMessage: 'All',
  },
  causeAll: {
    id: 'admin_tools_shared_reason_cause_all',
    defaultMessage: 'All',
  },
  FULL_ORDER_REFUND: {
    id: 'admin_tools_shared_reason_full_order_refund',
    defaultMessage: 'Full order refund',
  },
  PARTIAL_ORDER_REFUND: {
    id: 'admin_tools_shared_reason_partial_order_refund',
    defaultMessage: 'Partial order refund',
  },
  REPAIR_COSTS: {
    id: 'admin_tools_shared_reason_repair_costs',
    defaultMessage: 'Repair costs',
  },
  LOGISTIC_COSTS: {
    id: 'admin_tools_shared_reason_logistic_costs',
    defaultMessage: 'Logistic costs',
  },
  ACCESSORIES_COSTS: {
    id: 'admin_tools_shared_reason_accessories_costs',
    defaultMessage: 'Accessories costs',
  },
  MONEY_TRANSFER: {
    id: 'admin_tools_shared_reason_money_transfer',
    defaultMessage: 'Money transfer',
  },
  CARRIER_ISSUE: {
    id: 'admin_tools_shared_reason_carrier_issue',
    defaultMessage: 'Carrier issue',
  },
  WARRANTY_EXCLUSION: {
    id: 'admin_tools_shared_reason_warranty_exclusion',
    defaultMessage: 'Warranty exclusion',
  },
  DEVICE_STILL_ACCOUNT_LOCKED: {
    id: 'admin_tools_shared_reason_device_still_account_locked',
    defaultMessage: 'Device still account locked',
  },
  FBBM_DEADLINE: {
    id: 'admin_tools_shared_reason_fbbm_deadline',
    defaultMessage: 'FBBM deadline',
  },
  SSC_GESTURES: {
    id: 'admin_tools_shared_reason_ssc_gestures',
    defaultMessage: 'SSC gestures',
  },
  SUPPLY_TEAM_EXCEPTIONAL_REQUEST: {
    id: 'admin_tools_shared_reason_supply_team_exceptional_request',
    defaultMessage: 'Supply team exceptional request',
  },
  FINANCE_TEAM_EXCEPTIONAL_REQUEST: {
    id: 'admin_tools_shared_reason_finance_team_exceptional_request',
    defaultMessage: 'Finance team exceptional request',
  },
  BACKSHIP: {
    id: 'admin_tools_shared_reason_backship',
    defaultMessage: 'Backship',
  },
  BACKREPAIR: {
    id: 'admin_tools_shared_reason_backrepair',
    defaultMessage: 'Backrepair',
  },
  BACKREPAIR_WITH_ORDER: {
    id: 'admin_tools_shared_reason_backrepair_with_order',
    defaultMessage: 'Backrepair (with order)',
  },
  BACKREPAIR_WITHOUT_ORDER: {
    id: 'admin_tools_shared_reason_backrepair_without_order',
    defaultMessage: 'Backrepair (no order)',
  },
  BACKPARTS: {
    id: 'admin_tools_shared_reason_backparts',
    defaultMessage: 'Backparts',
  },
  BACKPACK: {
    id: 'admin_tools_shared_reason_backpack',
    defaultMessage: 'Backpack',
  },
  BUYBULK: {
    id: 'admin_tools_shared_reason_buybulk',
    defaultMessage: 'Buybulk',
  },
  INCORRECT_AMOUNT_REFUNDED: {
    id: 'admin_tools_shared_reason_incorrect_amount_refunded',
    defaultMessage: 'Incorrect amount refunded',
  },
  PROCESS_MISAPPLICATION: {
    id: 'admin_tools_shared_reason_process_misapplication',
    defaultMessage: 'Process misapplication',
  },
  INVESTING_COMPLEX_CASE: {
    id: 'admin_tools_shared_reason_investing_complex_case',
    defaultMessage:
      'Investing for seller & customer XP - Both for seller and customer XP',
  },
  INVESTING_ATTRIBUTABLE_TO_SELLER_XP: {
    id: 'admin_tools_shared_reason_attribuable_to_seller_xp',
    defaultMessage: 'Investing for seller & customer XP - Seller XP',
  },
  INVESTING_ATTRIBUTABLE_TO_CUSTOMER_XP: {
    id: 'admin_tools_shared_reason_attribuable_to_customer_xp',
    defaultMessage: 'Investing for seller & customer XP - Cust XP',
  },
  SELLER_AND_CUSTOMER_XP_BMA_ERROR: {
    id: 'admin_tools_shared_reason_seller_customer_xp_bma_error',
    defaultMessage: 'BMA error',
  },
  SELLER_AND_CUSTOMER_XP_BM_ERROR: {
    id: 'admin_tools_shared_reason_seller_customer_xp_bm_error',
    defaultMessage: 'BM error',
  },
  SELLER_AND_CUSTOMER_XP_OTHER_PARTNER_ERROR: {
    id: 'admin_tools_shared_reason_seller_customer_xp_other_partner_error',
    defaultMessage: 'Error from other partners',
  },
  BM_WALLET: {
    id: 'admin_tools_shared_reason_bm_wallet',
    defaultMessage: 'BM Wallet',
  },
  UNICITY_RULES_INVALID: {
    id: 'admin_tools_shared_reason_seller_unicity_rules_invalid',
    defaultMessage: 'Unicity rules invalid',
  },
  maximumValueError: {
    id: 'admin_tools_shared_reason_seller_form_maximum_value_error',
    defaultMessage: 'Value cannot exceed {maxValue}',
  },
}
